import { useMutation } from "react-query";
import axios from "../axios";
import { AddPaymentVAResponse } from "../../constants/types";

type GeneratePaymentVABody = {
    orderId?: string;
    ukmId?: string;
    layananId?: string;
    bank: string | null;
    voucherId?: string | number | null;
};

const generatePaymentVA = async (body: GeneratePaymentVABody) => {
    const response = await axios.post<AddPaymentVAResponse>(
        "/api/payment/generate",
        body,
    );
    return response.data;
};

export default function useGeneratePaymentVA() {
    return useMutation((body: GeneratePaymentVABody) =>
        generatePaymentVA(body),
    );
}
